import React, { Component } from "react";

class Button extends Component {
  render() {
    return <button>I&apos;m a test -child component- button</button>;
  }
}

export default Button;
